import { z } from "zod";

import {
  getTranslation,
  Resources,
} from "Infrastructure/Translations/Resources";

export const uploadMediaFileFormSchema = z.object({
  displayName: z
    .string()
    .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
  file: z.instanceof(File, {
    error: () => getTranslation(Resources.Validation.Required),
  }),
  licenseConfirmed: z.boolean().refine((value) => value === true, {
    error: () =>
      getTranslation(
        Resources.ApiErrors.CreatePartnerMediaFile.LicenseNotConfirmed,
      ),
  }),
});

export type UploadMediaFileFormData = z.infer<typeof uploadMediaFileFormSchema>;
